import React from 'react';
import PropTypes from 'prop-types';
import application_contants from '../../contants/application_contants';
import Evaluation_temp from './Timeline_evaluation/Evaluation_temp';


export default function Evaluation({ section_id, currentPhase = 1 }) {
  const prizes = [
    { img: application_contants.PrizeCupGold,   title: '1st Prize',      amount: '₹ 4,00,000 ' },
    { img: application_contants.PrizeCupSilver, title: '2nd Prize',amount: '₹ 3,00,000' },
    { img: application_contants.PrizeCupBronze, title: '3rd Prize',amount: '₹ 1,50,000' }
  ]

  const criteria = [
    { icon: application_contants.IconTime,  title: 'Submission',       text: "Submit trained models and an inference script. The inference script should take text and target speaker audio as input and synthesize the corresponding audio." },
    { icon: application_contants.IconCER,   title: 'Evaluation Metrics', text: "Evaluation metrics will include Word Error Rate (WER), Character Error Rate (CER), Mean Opinion Score (MOS) for naturalness and speaker similarity, model size, inference time, and FLOPs to generate 100 characters. Refer to sections below for exact splits." },
    // { icon: application_contants.IconWER,   title: 'Word',      text: "Measures how many words were incorrectly predicted compared to reference." },
    { icon: application_contants.IconWER ,   title: 'Round wise selection',   text: "Each round will feature a different evaluation set. Shortlisted participants from the online round will need to attend an offline event for final evaluation." },,
    { icon: application_contants.IconMOS, title: 'Evaluation Target Speakers',    text: "Samples of a few target speakers will be provided for reference, but the speakers in the evaluation set will be unknown." },
    { icon: application_contants.styleicon,  title: 'Punctuated Text',           text: "While the provided dataset will have normalized text, the evaluation set may contain unnormalized or code-switched sentences, and characters outside the provided datasets' character set. Participants are encouraged to augment their training with relevant external open-source datasets. " }
  ]

  const processPhases = [
    {
      number: 1,
      title: 'Round 1 Evaluation ',
      sub:   'Preliminary Selection',
      steps: [
        'The submission window remains open from TBD to 30 Nov.',
        'Round 1 submission requirements include: API endpoint, Technical write-up, Declaration of any additional data used and licensing, and ​ Participants must acknowledge open-sourcing of training data and tools used',
        'Evaluation timeline: 1st Dec-15 Dec',
        'Evaluation methods include: Automated scoring (WER, CER, and other metrics), and MoS (Mean Opinion Score) evaluation for top 5–10 entries',
        'There will be no public leaderboard; shortlisted teams are selected by jury',
        'Jury retains veto rights to select any exceptional or outlier submissions',
        'Shortlist announced early 15 Dec-20 Dec'

      ]
    },
    {
      number: 2,
      title: 'Round 2 Evaluation',
      sub:   'final event',
      steps: [
        'Round 2 will be held in-person in Jan 2026.',
        
        'Round 2 submission requirements include: Dockerized code, and Updated technical write-up',
        'Evaluation methods include: Automated metrics, and MoS evaluation by expert jury',
        'Final winners selected based on combined performance and innovation.',
        'In-person final event to be hosted at IISc Bangalore',
        'The event should include: Final evaluation and demos by shortlisted teams, Expert jury interaction and panel commentary, Media coverage, documentation, and branding, and Announcement of winners and prize distribution', 
        'We foresee the post-event wrap-up to include: Public declaration of results, Sharing of selected submissions (as per licensing), and Final report by the agency covering outreach, engagement, and impact'
      ]
    }
  ]

  const progressPct = (currentPhase - 1) / (processPhases.length - 1) * 100

  return (
    <section id={section_id} className="evaluation-section">
      <h2 className="h1-medium section-title title-navy-blue pb-2 about-title">Prizes</h2>
      {/* Prizes */}
      <div className="eval-prizes">
        {prizes.map(p => (
          <div key={p.title} className="eval-prize">
            <img src={p.img} alt={p.title} />
            <strong className="jostRegular h5-small section-title title-dark-grey">{p.title}</strong>
            <span className="eval-amount jostRegular h5-small section-title title-dark-grey">{p.amount}</span>
          </div>
        ))}
      </div>

      {/* Callout */}
      <div className="eval-callout section-title jostRegular h1-medium">
        Winning model to be deployed in maternal health assistant ( ARMMAN )
      </div>
      <br/>

      {/* Here Evaluation Flowchart importing */}
      <h2 className="h1-medium section-title title-navy-blue pb-2 about-title">Evaluation Process </h2>
      <Evaluation_temp />

      {/* Criteria */}
      <div className="eval-criteria">
        {criteria.map(c => (
          <div key={c.title} className="eval-card">
            <div className="eval-icon">
              <img src={c.icon} alt="" />
            </div>
            <h4 className="jostRegular h3-small section-title title-dark about-title">{c.title}</h4><br></br>
            <p className="jostRegular h6-small section-title title-dark-grey about-readmore-text">{c.text}</p>
          </div>
        ))}
      </div>
{/* Here Evaluation Flowchart importing */}
{/* <Evaluation_temp /> */}
      {/* Process */}
      {/* <h3 className="eval-section-title jostRegular h2-small section-title title-dark">Evaluation Criteria Process</h3>
      <div className="eval-process-bar">
        <div
          className="eval-process-progress"
          style={{ width: `${progressPct}%` }}
        />
        <div className="eval-process-base" />
      </div>
      <div className="eval-process-phases ">
        {processPhases.map(p => (
          <div key={p.number} className="eval-phase">
            <div className={`phase-number ${p.number <= currentPhase ? 'active' : ''} jostRegular h2-small section-title title-dark`} >
              {p.number}
            </div>
            <h4 className="h1-medium title-navy-blue pb-2 title">{p.title}</h4>
            <p className="phase-sub jostRegular h6-small section-title ">{p.sub}</p>
            <div className="phase-steps ">
              {p.steps.map((s, i) => (
                <div key={i} className="phase-step">
                  <span className="step-icon jostRegular h5-small section-title title-dark-grey">{i + 1}</span>
                  <span className='jostRegular h5-small section-title title-dark-grey'>{s}</span>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div> */}
    </section>
  )
}

Evaluation.propTypes = {
  section_id:  PropTypes.string.isRequired,
  currentPhase: PropTypes.number  // 1 or 2
}

Evaluation.defaultProps = {
  currentPhase: 1
}
